import React from 'react';
import { MarkdownRenderer } from "@lialo/pwa-ui/lib/MarkdownRenderer";

interface Props {
  content: string;
}

export const MarkdownContent = ({ content }: Props) => {
  return <MarkdownRenderer noSplitOnNewLine={true} source={content} />;
};
